export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6159.7ca9064e.jpg";